import { useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { useData } from "../../contexts/DataContext";
import { toast } from "sonner";

export function useTaskDetailActions({ task, setData, load, onClose }) {
  const { upsertTask, refreshTasks, removeTask } = useData();
  const [subtaskTitle, setSubtaskTitle] = useState("");
  const [uploading, setUploading] = useState(false);

  const patch = async (updates) => {
    try {
      const { data: updated } = await api.patch(`/tasks/${task.id}`, updates);
      setData((d) => ({ ...d, task: updated }));
      upsertTask(updated);
      refreshTasks();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const deleteTask = async () => {
    if (!window.confirm(`Delete "${task.title}"?`)) return;
    try {
      await api.delete(`/tasks/${task.id}`);
      removeTask(task.id);
      toast.success("Task deleted");
      onClose();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const addSubtask = async () => {
    if (!subtaskTitle.trim()) return;
    try {
      await api.post("/tasks", { project_id: task.project_id, parent_id: task.id, title: subtaskTitle.trim(), status: "todo", priority: "normal", assignees: [], due_date: null });
      setSubtaskTitle("");
      load();
      refreshTasks();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const toggleSubtask = async (sub) => {
    try {
      await api.patch(`/tasks/${sub.id}`, { status: sub.status === "done" ? "todo" : "done" });
      load();
      refreshTasks();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const upload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      await api.post(`/tasks/${task.id}/attachments`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      load();
      toast.success("File uploaded");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setUploading(false); e.target.value = ""; }
  };

  const deleteAttachment = async (att) => {
    try {
      await api.delete(`/attachments/${att.id}`);
      load();
    } catch (e) { toast.error(formatApiError(e)); }
  };

  return { patch, deleteTask, subtaskTitle, setSubtaskTitle, addSubtask, toggleSubtask, uploading, upload, deleteAttachment };
}
